export const isReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)',
).matches

export function isMobileView() {
  const mobileBreakpoint = getComputedStyle(document.documentElement)
    .getPropertyValue('--dds-breakpoints-small')
    .trim()

  const isMobileView = window.matchMedia(
    `(max-width: ${mobileBreakpoint})`,
  ).matches

  return isMobileView
}

export function setFromParentSize(element: HTMLElement) {
  const size = element.closest('dap-ds-card')?.getAttribute('size')
  element.setAttribute('size', size ?? 'sm')
}

export function numberRange(start: number, end: number): number[] {
  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}

export const JSONAttributeParser = (value: string | null) => {
  let convertedValue = {}
  try {
    convertedValue = JSON.parse(value ?? '')
  } catch (error) {
    console.error('Incorrect Json string data', {
      data: value,
    })
  }

  return convertedValue
}

export function getValidityStateObject(state: Partial<ValidityState>) {
  return {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: true,
    valueMissing: false,
    ...state,
  }
}
